/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import isNil from 'lodash/isNil';
import { requestStatuses } from '@gulfwinds/ui-components';

const initialState = {
  status: requestStatuses.INIT,
  error: null,
};

export const getPageData = createAsyncThunk(
  'pageStorage/getPageDataStatus',
  (request, { rejectWithValue }) => request().catch((error) => rejectWithValue({ error })),
  {
    condition: (_, { getState }) => {
      const { pageStorage } = getState();
      return !isNil(pageStorage) && pageStorage.status !== requestStatuses.PENDING;
    },
  },
);

const pageStorageSlice = createSlice({
  name: 'pageStorage',
  initialState,
  extraReducers: {
    [getPageData.pending]: () => ({
      status: requestStatuses.PENDING,
      error: null,
    }),
    [getPageData.fulfilled]: (_, { payload = {} }) => ({
      status: requestStatuses.SUCCESS,
      ...payload,
    }),
    [getPageData.rejected]: (_, { error }) => ({
      status: requestStatuses.FAILED,
      error,
    }),
  },
});

export default pageStorageSlice.reducer;
